// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"276e0956","806":"b90eabbf"}[chunkId] + ".chunk.js";
};